import {getLang, langArg, jsRangeDatePicker, dropzoneInit} from "./form-engine-fe-pre";
import {dTree} from "./d-tree";
import {dTreeUI} from "./d-tree-ui";

window.getLang=getLang;
window.langArg=langArg;
window.jsRangeDatePicker=jsRangeDatePicker;
window.dropzoneInit=dropzoneInit;

window.dTree=dTree;
window.dTreeUI=dTreeUI;


if (typeof Dropzone == 'function') {
    Dropzone.autoDiscover = false;
}

$(function () {
    'use strict';
    jsRangeDatePicker.init();
});

$('.btn--modify').click(function () {
    $('.hiddenRecaptcha').prop("disabled", true);
});
